import styled from '@emotion/styled'

export const DropzoneContainer = styled.div({
  marginTop: '10px',
  display: 'flex',

  '.inputContent': {
    display: 'flex',
    flex: 1,
    width: '100%',
  },

  '.dropArea': {
    cursor: 'pointer',
    display: 'flex',
    background: '#FFF',
    border: 'dashed 1.5px #e4e4e7',
    borderRadius: '5px',
    padding: '20px 0px',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    flex: 1,
    width: '100%',

    '.textTitle': {
      fontSize: '1.25rem',
      color: '#505050',

      svg: {
        fontSize: '1rem',

        path: {
          color: '#000',
        },
      },
    },

    '.buttonUI': {
      height: '35px',
      background: '#e4e4e7',
      borderRadius: '5px',
      fontSize: '1.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '200px',
      color: '#505050',
    },
  },

  '.dropArea.error': {
    backgroundColor: '#fff6f6',
    borderColor: '#e0b4b4',
  },
})

export const FileUploadCellContainer = styled.div({
  display: 'flex',
  minHeight: '40px',
  border: `solid 1px #BDBDBD`,
  borderRadius: '5px',
  boxShadow: `#BDBDBD`,
  alignItems: 'center',
  marginTop: '15px',
  width: '100%',
  wordWrap: 'anywhere',
  wordBreak: 'break-word',
  justifyContent: 'space-between',

  '& .left, & .right': {
    display: 'flex',
    alignItems: 'center',
  },

  '& .left': {
    maxWidth:'80%',
    minWidth:'60%',
  },

  '& .right': {
    maxWidth:'40%',
    justifyContent: 'flex-end',
  },

  '& .right button.ui.button': {
    marginLeft: '10px',
    marginRight: '0px',
    borderRadius: '0px 5px 5px 0px',
    background: 'transparent',
    borderLeft: `solid 1px #BDBDBD`,
  },

  '& .right button.ui.button svg path': {
    color: 'red',
  },

  '.iconContent': {
    display: 'flex',
    height: 'auto',
    width: '40px',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '.iconContent svg path': {
    color: `${props => props.pendingDelete ? '#BDBDBD' : '#FBBF66'}`,
  },

  '.titleContent': {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    fontSize: '1.125rem',
  },

  '.fileNameContent': {
    color: `${props => props.pendingDelete ? '#BDBDBD' : '#000'}`,
    textDecoration: `${props => props.pendingDelete ? 'line-through' : 'none'}`,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    overflow: 'hidden',
    maxWidth:'100%'
  },

  '.fileSizeContent': {
    whiteSpace: 'nowrap',
    color: `${props => props.pendingDelete ? '#BDBDBD' : '#000'}`,
    textDecoration: `${props => props.pendingDelete ? 'line-through' : 'none'}`,
  },

  '@media only screen and (min-width: 600px)': {
    whiteSpace: 'nowrap',
  },

  '@media only screen and (min-width: 769px)': {
    whiteSpace: 'nowrap',
  },
})